/**
 * BB-8 work order Stage 1-6: agent-facing translations for the
 * backend's normalized `PresenceFailureReason` values
 * (backend/app/telephony/presence/contracts.py). Mirrors
 * campaignLoginFailureCopy.js's own discipline exactly -- never
 * surfaces MariaDB/VICIdial topology, usernames, passwords, session
 * tokens, raw provider responses, exception strings, or machine-auth
 * detail; every value here is a short, fixed, reviewed sentence.
 */
export const PRESENCE_FAILURE_COPY = Object.freeze({
  session_context_missing: "Your session needs to be refreshed. Log in again.",
  session_context_campaign_mismatch: "Your session doesn't match this campaign. Log in again.",
  session_context_stale: "Your session has expired. Log in again.",
  session_context_resolution_failed: "Your session couldn't be verified. Log in again.",
  credential_missing: "Your dialer credential isn't set up yet. Contact your administrator.",
  credential_resolution_failed: "Your dialer credential couldn't be verified. Contact your administrator.",
  agent_log_id_unavailable: "Couldn't confirm your session. Try again.",
  provider_query_adapter_unavailable: "The dialer is temporarily unavailable. Try again in a moment.",
  machine_auth_failure: "The dialer is temporarily unavailable. Try again in a moment.",
  native_dispatch_transport_failure: "The dialer is temporarily unavailable. Try again in a moment.",
  no_live_agent_row: "This didn't complete. Try again.",
  wrong_campaign: "This completed for a different campaign than requested. Try again.",
  wrong_user: "This didn't complete as expected. Try again.",
  unexpected_status: "This didn't complete as expected. Try again.",
  malformed_provider_response: "The dialer returned an unexpected response. Try again.",
  stale_observation: "Couldn't confirm this in time. Try again.",
  timeout: "This timed out. Try again.",
});

export const DEFAULT_PRESENCE_FAILURE_MESSAGE = "This didn't complete. Try again.";

export function presenceFailureMessage(failureReason) {
  if (!failureReason) return DEFAULT_PRESENCE_FAILURE_MESSAGE;
  return PRESENCE_FAILURE_COPY[failureReason] || DEFAULT_PRESENCE_FAILURE_MESSAGE;
}
